'use client';

import {useRouter} from 'next/navigation';
import {useEffect, useState} from 'react';
import Link from '@/links';
import PropTypes from 'prop-types';

const propTypes = {
  fallbackHref: PropTypes.string,
  label: PropTypes.string
};

export default function GoBackLink({fallbackHref = '/partnership-program', label = 'Go back'}) {
  const router = useRouter();
  const [canGoBack, setCanGoBack] = useState(false);

  useEffect(() => {
    const {state} = window.history;
    const currentPath = window.location.pathname;

    // Check if page was opened in a new tab or accessed directly
    const isNewTab = window.history.length === 1;
    const isDirectAccess = !document.referrer;
    const hasDifferentState = state?.url ? !state.url.includes(currentPath) : false;
    const isInternalReferrer = document.referrer.includes(window.location.hostname);
    const hasHistory = window.history.length > 1;

    setCanGoBack(
      !isNewTab && !isDirectAccess && (hasHistory || hasDifferentState || isInternalReferrer)
    );
  }, []);

  const handleClick = e => {
    e.preventDefault();

    if (canGoBack) {
      router.back();
    } else {
      router.push(fallbackHref);
    }
  };

  return (
    <Link onClick={handleClick} variant="cta-default-xs-light-reverse">
      {label}
    </Link>
  );
}

GoBackLink.propTypes = propTypes;
